<template>
  <div
    v-if="hasSlotDefault"
    class="sidebar-footer">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {
    hasSlotDefault() {
      return !!this.$slots.default;
    }
  }
};
</script>
